/**
 * Private modules
 */
const {
  createQueryComponent,
  customerId,
  dealId,
  objectIds,
  systemGameId,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  createCustomerDealSchedulesByDealId: {
    properties: {
      params: {
        properties: {
          customerId,
          dealId,
        },
        required: [
          'customerId',
          'dealId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  deleteCustomerDealSchedulesBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerDealSchedulesBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
